export default {
  SKUPREME: {
    logo: '/black-logo.png',
    name: 'Skupreme',
    siteURL: 'https://skupreme.com',
    loginURL: '/login',
    signupUrl: 'https://skupreme.com/schedule-meeting',
    icon: '/images/logo-small-green.svg',
    accentColor: '#3EC247',
    hideSections: {
      analytics: {
        setup: false,
        purchaseOrders: false,
        orders: false,
        shipments: false,
      },
      orders: [],
    },
    registerURL: 'https://skupreme.com/schedule-meeting',
    blockedOperations: {
      cancelFulfillment: false,
      cancelOrder: false,
    },
  },
  TACTICAL: {
    logo: '/images/tactical/logo-tactical.svg',
    name: 'Tactical',
    siteURL: 'https://tacticalfulfillment.com',
    signupUrl: 'https://tacticalfulfillment.com/register',
    loginURL: '/login',
    icon: '/images/tactical/tactical.svg',
    accentColor: '#2596be',
    hideSections: {
      analytics: {
        setup: true,
        purchaseOrders: true,
        orders: false,
        shipments: false,
      },
      orders: ['B2B'],
    },
    registerURL: '/register',
    blockedOperations: {
      cancelFulfillment: true,
      cancelOrder: true,
    },
  },
};
